import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// services
import * as StripeService from '_services/stripe-service';

const initialState = {
    stripe: {},

    // payment intent
    paymentIntent: null,
    getPaymentIntentStatus: 'idle',
    getPaymentIntentError: null,

    expressIntent: 'idle', // for express pay
    getPaymentExpressIntentStatus: 'idle',
    getPaymentIntentExpressError: null,

    status: 'idle',
    error: null
};

export const getPaymentIntent = createAsyncThunk('stripe/getPaymentIntent', async (paymentObject) => {
    return StripeService.getPaymentIntent(paymentObject);
})

export const getPaymentIntentExpressPay = createAsyncThunk('stripe/getPaymentIntentExpressPay', async (paymentObject) => {
    return StripeService.getPaymentIntentExpressPay(paymentObject);
})

const stripeSlice = createSlice({
    name: 'stripe',
    initialState,
    reducers: {
        reset: (state) => initialState,

        resetExpressIntent: (state) => {
        state.getPaymentExpressIntentStatus = 'idle';
        state.getPaymentIntentExpressError = null;
        state.expressIntent = null;
    },
    },
    extraReducers: {
        [getPaymentIntent.pending]: (state) => {
            state.getPaymentIntentStatus = 'loading';
            state.getPaymentIntentError = null;
            state.paymentIntent = null;
        },
        [getPaymentIntent.fulfilled]: (state, action) => {
            state.getPaymentIntentStatus = 'succeeded';
            state.paymentIntent = action.payload;
        },
        [getPaymentIntent.rejected]: (state, action) => {
            state.getPaymentIntentStatus = 'failed';
            state.getPaymentIntentError = action.error.message;
        },
        [getPaymentIntentExpressPay.pending]: (state) => {
            state.getPaymentExpressIntentStatus = 'loading';
            state.getPaymentIntentExpressError = null;
        },
        [getPaymentIntentExpressPay.fulfilled]: (state, action) => {
            state.getPaymentExpressIntentStatus = 'succeeded';
            state.expressIntent = action.payload;
        },
        [getPaymentIntentExpressPay.rejected]: (state, action) => {
            state.getPaymentExpressIntentStatus = 'failed';
            state.getPaymentIntentExpressError = action.error.message;
        }
    }
});

export const { reset, resetExpressIntent } = stripeSlice.actions;

// selectors
export const selectStripe = (state) => state.stripe.stripe;

// payment intent selectors
export const selectPaymentIntent = (state) => state.stripe.paymentIntent;
export const selectGetPaymentIntentStatus = (state) => state.stripe.getPaymentIntentStatus;
export const selectGetPaymentIntentError = (state) => state.stripe.getPaymentIntentError;

export const selectGetPaymentExpressIntentStatus = (state) => state.stripe.getPaymentExpressIntentStatus;   // for express pay
export const selectGetPaymentExpressIntentError = (state) => state.stripe.getPaymentExpressIntentError;   // for express pay
export const selectExpressIntent = (state) => state.stripe.expressIntent;   // for express pay

export default stripeSlice.reducer;
